import { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);
  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Logs" description="Full activity trail across modules." />
      <Card className="p-0 overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>Actor</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id}>
                <TableCell className="text-xs font-mono">{fmtDateTime(l.created_at)}</TableCell>
                <TableCell className="text-xs font-mono">{(l.actor_id || "").slice(0, 8)}</TableCell>
                <TableCell><span className="text-xs px-2 py-0.5 rounded-full bg-slate-100 capitalize">{l.action.replace(/_/g, " ")}</span></TableCell>
                <TableCell className="text-xs">{l.entity_type}</TableCell>
                <TableCell className="text-xs text-slate-500 max-w-md truncate">{JSON.stringify(l.details || {})}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-slate-500 py-10">No audit entries.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
